import React, { useCallback, useEffect, useMemo, useState } from "react";
import Errors from "../../../constants/Errors.json";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import Papa from "papaparse";
import variables from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import {
  BottomSectionModal,
  NotesSection,
  UploadCsvOption,
} from "../../../constants/assets/containers";
import FileUpload from "../../Common/FileUpload";
import InformationBar from "../../Common/InformationBar";
import Button from "sushiweb/Button";
import * as UserActions from "../../../store/actions/User";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import * as ConfigChangeLogActions from "../../../store/actions/Namespace";
import { getPath } from "../../../utils";

const BulkUploadConfig = ({
  instructions, //set of instructions or note
  sampleURL, //sample url of file to download
  filename, //filename to be send in payload
  setStatus,
  setUploadedFileName,
  setActiveFilePath,
  heading, //heading of the modal
  id, //id of the modal (mandatory field)
  btnDataTestID, //data-testid of confirm button (mandatory field for testing)
  keyName, //keyName of the key to be send in acknowledgement
  uploadUrl, //upoadUrl is the url on which the ack will be sent
  sendExtraAck, //pass boolean value if to pass filepath as extra param or not in ack call
  getUploadUrl, //function for api call
  closeUrl, // url where it should redirect when closed
  customHandleClose, // pass function if want to handle modal close by yourself
  useUserUploadedFilename, // pass boolean value if to use filename of file uploaded by user or not
  filterTypes = [], // array of values for filtering
  filterTypeSampleCsvUrlMap = {}, // map of filter type and sample csv download url
  validationType = "", // for CSV file validation of your choice
  maxSize, //maximum file size in MB
  acceptedFileFormat,
  noAckCall,
  getNamespacesApi,
}) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState({});
  // const [namespaces, setNamespaces] = useState([]);
  const [presign_url, setPresign_url] = useState("");
  const [csv_type, setCsvType] = useState("");
  const [file_path, setFile_path] = useState("");
  const [sample_download_url, setSampleDownloadUrl] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleURL}`
        : ""
    }`;

    if (sampleURL) {
      setSampleDownloadUrl(download_url);
    }
  }, []);

  const handleClose = useCallback(() => {
    if (customHandleClose) {
      customHandleClose();
      return;
    }
    if (closeUrl) {
      history.push(closeUrl);
    } else {
      history.push("/");
    }
  }, [closeUrl, customHandleClose]);

  const handleFileUploadSuccess = () => {
    if (activeFile.name) {
      setUploadedFileName(activeFile.name);
    }
    setActiveFilePath(file_path);
  };

  const handleSubmit = (e) => {
    setLoadingBtn(true);
    e.preventDefault();

    const reader = new FileReader();
    reader.onload = () => {
      const csvContent = reader.result;
      const uniqueNamespaces = getNamespaces(csvContent);
      var readActionsRequired = [],
        writeActionsRequired = [];
      const namespaceReadActions = [], namespaceWriteActions = [];  
      getNamespacesApi({ limit: 100 }).then((response) => {
        const allNamespaces = getPath(response, "namespaces", []);
        allNamespaces.map((namespace) => {
          if (uniqueNamespaces.has(getPath(namespace, "namespace", ""))) {
            readActionsRequired.push(
              ...getPath(namespace, "configActions.read", [])
            );
            writeActionsRequired.push(
              ...getPath(namespace, "configActions.write", [])
            );
            namespaceReadActions.push(
              ...getPath(namespace, "namespaceActions.read", [])
            );
            namespaceWriteActions.push(
              ...getPath(namespace, "namespaceActions.write", [])
            );
          }
        });

        if (useUserUploadedFilename) {
          filename = activeFile.name;
        }

        const namespaces = Array.from(uniqueNamespaces);
        getUploadUrl({
          filename: filename || "bulk_upload_file",
        }).then((res) => {
          setTimeout(() => setLoadingBtn(false), 3000);
          if (res) {
            setFile_path(res.file_path);
            setCallback_key({
              namespaces,
              actionsRequired: {
                read: readActionsRequired,
                write: writeActionsRequired,
              },
              namespaceReadActions: {
                read: namespaceReadActions,
                write: namespaceWriteActions
              }
            });
            setPresign_url(res.file_upload_url);
          } else {
            setStatus({ type: "error", message: Errors.GENERAL_ERROR });
          }
        });
      });
    };
    reader.readAsText(activeFile);
  };

  const getNamespaces = (csvContent) => {
    const csv = Papa.parse(csvContent, {
      header: true,
    });
    const parsedData = csv?.data;
    const rows = Object.keys(parsedData[0]);

    const columns = Object.values(parsedData[0]);
    return parsedData.reduce((acc, e, i) => {
      acc.add(Object.values(e)[0]);
      return acc;
    }, new Set());
  };

  const handleChange = (key, val) => {
    setCsvType(val);
    if (val === "") {
      setSampleDownloadUrl("");
      return;
    }

    const sampleCSVDownloadURL = filterTypeSampleCsvUrlMap[val];

    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleCSVDownloadURL}`
        : ""
    }`;

    setSampleDownloadUrl(download_url);
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "" || (filterTypes.length > 0 && csv_type === "");
  };
  const extraParamsAckObj = useMemo(() => {
    return sendExtraAck
      ? { file_path: file_path, presign_url: presign_url, csv_type: csv_type }
      : {};
  }, [sendExtraAck, file_path, presign_url]);

  const CSVDropDown = () => {
    if (filterTypes.length > 0) {
      return (
        <PaginatedReactDropdown
          options={filterTypes}
          handleChange={handleChange}
          keyToChange="csv_type"
          placeholder="CSV Type"
          showCross={true}
          id="fileTypeDropdown"
          showPagination={false}
          value={csv_type}
        />
      );
    }
    return null;
  };

  return (
    <section>
      <NoFooterModal
        header
        heading={heading || "Bulk File Upload"}
        handleClose={handleClose}
        id={id || "bulkUploadModal"}
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid={btnDataTestID}
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              loading={loadingBtn}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <CSVDropDown />

        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl={uploadUrl}
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName={keyName || "callback_key"}
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            maxSize={maxSize}
            extraParamsAckObj={extraParamsAckObj}
            acceptTypes={
              acceptedFileFormat ? acceptedFileFormat : ".csv, .xls, .xlsx"
            }
            handleFileUploadSuccess={handleFileUploadSuccess}
            validationType={validationType}
            noAckCall={noAckCall}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </section>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
    getNamespacesApi: bindActionCreators(
      ConfigChangeLogActions.getNamespaces,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadConfig);
